/**
 * PUCCI × XGEN — Recommendations
 * ───────────────────────────────
 * Fetches and renders xRecommend products via xg.recommend API.
 * Depends on xgen-helpers.js (window.xgenHelpers).
 */

(function () {
  'use strict';

  if (window._xgenRecInit) return;
  window._xgenRecInit = true;

  const XGEN_DEPLOYMENT = '9b500812-61b0-452f-a107-deafaed548d6';

  const SPINNER = `<div class="loading-overlay__spinner hidden"><svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>`;
  const CLOSE_ICON = `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17"><path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"/></svg>`;

  const WISHLIST_ICON_EMPTY = `<svg xmlns="http://www.w3.org/2000/svg" width="21" height="19" viewBox="0 0 21 19" fill="none"><path d="M10.5002 18.1539L9.69064 17.4135C7.947 15.801 6.50469 14.4207 5.36372 13.2727C4.22275 12.1247 3.32216 11.1122 2.66196 10.2352C2.00175 9.35826 1.54051 8.56484 1.27822 7.85496C1.01592 7.14506 0.884766 6.43101 0.884766 5.71281C0.884766 4.33739 1.34636 3.18244 2.26954 2.24794C3.19272 1.31344 4.3337 0.846191 5.69246 0.846191C6.63208 0.846191 7.51349 1.08952 8.33669 1.57618C9.15989 2.06285 9.88104 2.77065 10.5002 3.6996C11.1193 2.77065 11.8404 2.06285 12.6636 1.57618C13.4868 1.08952 14.3682 0.846191 15.3078 0.846191C16.6666 0.846191 17.8076 1.31344 18.7308 2.24794C19.6539 3.18244 20.1155 4.33739 20.1155 5.71281C20.1155 6.43101 19.9844 7.14506 19.7221 7.85496C19.4598 8.56484 18.9985 9.35826 18.3383 10.2352C17.6781 11.1122 16.781 12.1247 15.6469 13.2727C14.5127 14.4207 13.067 15.801 11.3097 17.4135L10.5002 18.1539Z" fill="transparent" stroke="black"/></svg>`;
  const WISHLIST_ICON_FULL = `<svg xmlns="http://www.w3.org/2000/svg" width="21" height="19" viewBox="0 0 21 19" fill="none"><path d="M10.5002 18.1539L9.69064 17.4135C7.947 15.801 6.50469 14.4207 5.36372 13.2727C4.22275 12.1247 3.32216 11.1122 2.66196 10.2352C2.00175 9.35826 1.54051 8.56484 1.27822 7.85496C1.01592 7.14506 0.884766 6.43101 0.884766 5.71281C0.884766 4.33739 1.34636 3.18244 2.26954 2.24794C3.19272 1.31344 4.3337 0.846191 5.69246 0.846191C6.63208 0.846191 7.51349 1.08952 8.33669 1.57618C9.15989 2.06285 9.88104 2.77065 10.5002 3.6996C11.1193 2.77065 11.8404 2.06285 12.6636 1.57618C13.4868 1.08952 14.3682 0.846191 15.3078 0.846191C16.6666 0.846191 17.8076 1.31344 18.7308 2.24794C19.6539 3.18244 20.1155 4.33739 20.1155 5.71281C20.1155 6.43101 19.9844 7.14506 19.7221 7.85496C19.4598 8.56484 18.9985 9.35826 18.3383 10.2352C17.6781 11.1122 16.781 12.1247 15.6469 13.2727C14.5127 14.4207 13.067 15.801 11.3097 17.4135L10.5002 18.1539Z" fill="black" stroke="black"/></svg>`;

  let recSwat = null;
  let recWishlistListId = null;
  let recWishlistedSet = {};

  // ─── UTILS ────────────────────────────────────────────────────────────────
  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
  function escapeAttr(str) {
    return String(str).replace(/"/g, '&quot;');
  }

  function isCustomerLoggedIn() {
    return !!document.getElementById('cm');
  }

  // ─── CARD HTML ─────────────────────────────────────────────────────────────
  function buildRecCardHtml(item, index, total, gridId, { showWishlist = true, showQuickbuy = true, onlyOneImg = false, priceInHover = false, elementId = XGEN_DEPLOYMENT } = {}) {
    const helpers = window.xgenHelpers;
    const rawUrl = item.link || item.product_url || item.url || (item.handle ? `/products/${item.handle}` : '#');
    const localizedUrl = helpers ? helpers.localizeProductUrl(rawUrl) : rawUrl;
    // XRecommend attribution uses the experience/element id (sm_el_XXXXXX), not the deployment id
    // — that format is reserved for XSearch links (see xgen-search.js).
    const url = helpers
      ? helpers.appendXseParams(localizedUrl, item.prod_code, elementId)
      : localizedUrl;

    const title = item.prod_name || item.title || item.name || '';
    const isOnSale = item.sale_class === 'xse_sale';
    const currentPrice = item.localized_price || '';
    const originalPrice = item.localized_compare_price || '';

    const allImages = [];
    if (item.images && Array.isArray(item.images)) {
      item.images.forEach(img => {
        const src = typeof img === 'string' ? img : (img.url || img.src || '');
        if (src) allImages.push(src);
      });
    }
    if (allImages.length === 0 && item.image) allImages.push(item.image);
    if (allImages.length === 0 && item.thumbnail) allImages.push(item.thumbnail);

    const images = allImages.slice(0, onlyOneImg ? 1 : 5);
    console.log('[XGen Rec] ' + (item.prod_name || item.title) + ' → item.images: ' + (item.images?.length ?? 0) + ', allImages: ' + allImages.length);
    const slideCount = Math.max(images.length, 1);
    const hasMultiple = slideCount > 1;
    const productId = item.shopify_id || item.prod_code || '';
    const loggedIn = isCustomerLoggedIn();

    let priceHtml = '';
    if (isOnSale && originalPrice && originalPrice !== currentPrice) {
      priceHtml = `
        <div class="price price--on-sale">
          <div class="price__sale">
            <span class="price-item price-item--sale">${escapeHtml(currentPrice)}</span>
            <s class="price-item price-item--regular">${escapeHtml(originalPrice)}</s>
          </div>
        </div>`;
    } else if (currentPrice) {
      priceHtml = `
        <div class="price">
          <div class="price__regular">
            <span class="price-item price-item--regular">${escapeHtml(currentPrice)}</span>
          </div>
        </div>`;
    }

    // Badges — same convention as fostr-product-badges.liquid: tags prefixed with ':' are customer-facing
    // Always print the wrapping div so card titles stay vertically aligned across items;
    // fall back to a non-breaking space (an empty span collapses to 0 height) when there's no badge.
    const badges = String(item.tags || '')
      .split(',')
      .map(t => t.trim())
      .filter(t => t.startsWith(':'))
      .map(t => `<span class="custom-badge">${escapeHtml(t.slice(1))}</span>`)
      .join('');
    const badgeHtml = `<div class="card__badge top left" style="margin-bottom: 5px;">${badges || '<span class="custom-badge">&nbsp;</span>'}</div>`;

    // Quick buy — trigger button only; modal is built lazily on click with fresh Shopify data
    const CART_ICON = `<svg class="icon icon-cart-empty" aria-hidden="true" focusable="false" role="presentation" width="18" height="21" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="-1 0 19 21"><path d="M14.47 7H2c-.83 3-2.2 9.4-1 11 1.5 2 13.5 1.5 15 0 1.17-1.2-.53-7.83-1.53-11ZM4 7C3.64 4.83 4.07.5 8.47.5S13.31 4.83 13 7" stroke="black"/></svg>`;

    let quickBuyHtml = '';
    if (showQuickbuy && productId) {
      quickBuyHtml = `
        <div class="xgen-qs-opener no-js-hidden">
          <button type="button" aria-haspopup="dialog"
            class="product-form__submit button button--full-width button--primary product-popup-modal__button link xgen-qs-trigger"
            data-product-url="${escapeAttr(localizedUrl)}"
            data-product-id="${escapeAttr(String(productId))}">
            ${CART_ICON}
          </button>
        </div>`;
    }

    let wishlistBtnHtml = '';
    if (showWishlist && productId) {
      if (loggedIn) {
        const inWl = !!recWishlistedSet[String(productId)];
        wishlistBtnHtml = `
          <button class="xgen-rec-wishlist-btn${inWl ? ' xgen-wl-added' : ''}"
            data-empi="${escapeAttr(productId)}"
            data-product-url="${escapeAttr(localizedUrl)}"
            aria-label="wishlist">
            ${inWl ? WISHLIST_ICON_FULL : WISHLIST_ICON_EMPTY}
          </button>`;
      } else {
        wishlistBtnHtml = `
          <button class="xgen-rec-wishlist-btn xgen-wishlist-trigger" data-login-popup-trigger aria-label="wishlist">
            ${WISHLIST_ICON_EMPTY}
          </button>`;
      }
    }

    // Cart drawer cards hide the permanent card__content block (no room for it), so the
    // price rides along as its own band right under the image, revealed on hover.
    const hoverPriceHtml = priceInHover && priceHtml
      ? `<div class="xgen-rec-hover-price-band">${priceHtml}</div>`
      : '';

    const wishlistHtml = wishlistBtnHtml
      ? `<div class="xgen-rec-hover-elements">${wishlistBtnHtml}</div>`
      : '';

    return `
      <div id="Slide-${escapeAttr(gridId)}-${index}" class="grid__item slider__slide" role="group" aria-label="slide ${index} of ${total}" data-prod-code="${escapeAttr(item.prod_code || '')}">
        <div class="card-wrapper underline-links-hover xgen-rec-card-wrapper">
          <div class="card card--card card--media" style="--ratio-percent:151.3%;">
            <div class="card__inner ratio">
              <div class="card__media">
                <div class="the-collection-product-media media media--transparent media--hover-effect">
                  <div class="xgen-rec-card-media" data-slide-count="${slideCount}" data-slide-visual="0">
                    <div class="xgen-rec-card-track" style="transform:${hasMultiple ? 'translateX(calc(-100% - var(--xgen-card-gap, 0px)))' : 'translateX(0)'}">
                      ${(() => {
                        const slide = src => `
                        <div class="xgen-rec-card-slide">
                          <a href="${escapeAttr(url)}" class="full-unstyled-link">
                            <img class="xgen-rec-card-img" src="${escapeAttr(src)}&width=400" alt="${escapeAttr(title)}" loading="lazy" />
                          </a>
                        </div>`;
                        // Clone the last image before the first and the first image after the last
                        // so the track can keep sliding past the edge and snap back invisibly (seamless loop).
                        return (hasMultiple ? slide(images[images.length - 1]) : '')
                          + images.map(slide).join('')
                          + (hasMultiple ? slide(images[0]) : '');
                      })()}
                    </div>
                    ${hasMultiple ? `
                      <button class="xgen-rec-arrow xgen-rec-arrow--prev" aria-label="Previous" tabindex="-1">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.60714 10L15 16.3137L14.1964 17L6 10L14.1964 3L15 3.68627L7.60714 10Z" fill="black"/></svg>
                      </button>
                      <button class="xgen-rec-arrow xgen-rec-arrow--next" aria-label="Next" tabindex="-1">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.3929 10L5 3.68627L5.80357 3L14 10L5.80357 17L5 16.3137L12.3929 10Z" fill="black"/></svg>
                      </button>` : ''}
                  </div>
                </div>
              </div>
              ${wishlistHtml}
            </div>
            ${hoverPriceHtml}
            <div class="card__content">
              <div class="card__information">
                ${badgeHtml}
                <span class="card__heading">
                  <a href="${escapeAttr(url)}" class="full-unstyled-link">${escapeHtml(title)}</a>
                </span>
                <div class="card-information">${priceHtml}</div>
              </div>
              ${quickBuyHtml}
            </div>
          </div>
        </div>
      </div>`;
  }

  // ─── QUICK SHOP ───────────────────────────────────────────────────────────
  const QS_FETCH_CACHE = {}; // cache per page load

  // Parses accurate variant availability from Liquid-rendered HTML.
  // The storefront .json endpoint doesn't always respect multi-location inventory;
  // Liquid-rendered HTML does. Uses pathname (same-origin) to respect session/cookies.
  function parseAvailabilityFromHtml(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const map = {};
    doc.querySelectorAll('input[data-variant]').forEach(input => {
      const vid = input.dataset.variant;
      if (!vid) return;
      const label = doc.querySelector(`label[for="${input.id}"]`);
      map[vid] = !label?.classList.contains('unavailable');
    });
    return map;
  }

  async function fetchVariantAvailability(productUrl) {
    // Always use relative pathname — same origin ensures correct session/market cookies
    let pathname;
    try { pathname = new URL(productUrl, window.location.origin).pathname; }
    catch { pathname = productUrl; }

    // 1st attempt: section rendering API (faster, smaller)
    try {
      const res = await fetch(`${pathname}?sections=main-product`);
      if (res.ok) {
        const json = await res.json();
        const html = json?.['main-product'];
        if (html) {
          const map = parseAvailabilityFromHtml(html);
          if (Object.keys(map).length > 0) {
            console.log('[XGen QS] availability from sections API:', map);
            return map;
          }
        }
      }
    } catch (e) { console.warn('[XGen QS] sections API failed:', e); }

    // 2nd attempt: full product page HTML
    try {
      const res = await fetch(pathname);
      if (res.ok) {
        const html = await res.text();
        const map = parseAvailabilityFromHtml(html);
        console.log('[XGen QS] availability from full page:', map);
        return map;
      }
    } catch (e) { console.warn('[XGen QS] full page fetch failed:', e); }

    return {};
  }

  function buildQuickShopModalEl(productData, productId, productUrl, { addText, selectText, viewText, availabilityMap = {} }) {
    const variants = productData.variants || [];
    const productTitle = productData.title || '';
    const productOptions = productData.options || [];
    const hasAccurateAvail = Object.keys(availabilityMap).length > 0;

    // Find size option key ("Taglia" / "Size") so buttons show "38" not "NERO / 38"
    const sizeOptIdx = productOptions.findIndex(o => /taglia|size|misura/i.test(o.name || ''));
    const sizeKey = sizeOptIdx >= 0 ? `option${sizeOptIdx + 1}` : null;

    // Deduplicate by size label; use accurate Liquid availability if available
    const sizeMap = new Map();
    variants.forEach(v => {
      const label = sizeKey && v[sizeKey] ? v[sizeKey] : v.title;
      const vid = String(v.id);
      // Prefer section-rendered availability (Liquid, multi-location aware) over JSON
      const isAvailable = hasAccurateAvail ? (availabilityMap[vid] ?? false) : !!v.available;
      const existing = sizeMap.get(label);
      if (!existing || (isAvailable && !existing.available)) {
        sizeMap.set(label, { variantId: vid, available: isAvailable, label });
      }
    });
    const sizeOptions = Array.from(sizeMap.values());
    const hasOnlyDefault = variants.length === 1 && /^default/i.test(variants[0]?.title || '');
    const needsSizeSelect = sizeOptions.length > 1 && !hasOnlyDefault;
    // allOos bypass only when we have NO accurate data (section fetch failed, using .json fallback)
    const allOos = !hasAccurateAvail && sizeOptions.length > 0 && sizeOptions.every(s => !s.available);
    const firstVariantId = (sizeOptions.find(s => s.available) || sizeOptions[0])?.variantId || '';

    // Price — storefront .json prices are decimal strings in currency units ("1100.00")
    let priceHtml = '';
    const v0 = variants[0];
    if (v0) {
      const helpers = window.xgenHelpers;
      const fmt = p => helpers ? helpers.formatPrice(parseFloat(p)) : `€${parseFloat(p)}`;
      const compareAt = v0.compare_at_price ? parseFloat(v0.compare_at_price) : null;
      const price = parseFloat(v0.price);
      if (compareAt && compareAt > price) {
        priceHtml = `<div class="price price--on-sale"><div class="price__sale">
          <span class="price-item price-item--sale">${escapeHtml(fmt(v0.price))}</span>
          <s class="price-item price-item--regular">${escapeHtml(fmt(v0.compare_at_price))}</s>
        </div></div>`;
      } else {
        priceHtml = `<div class="price"><div class="price__regular">
          <span class="price-item price-item--regular">${escapeHtml(fmt(v0.price))}</span>
        </div></div>`;
      }
    }

    // Featured image
    const featuredRaw = productData.featured_image;
    const imgSrc = featuredRaw
      ? (typeof featuredRaw === 'string' ? featuredRaw : (featuredRaw.src || ''))
      : (productData.images?.[0]?.src || '');
    const imgTag = imgSrc
      ? `<div class="qs-product-media grid__item product__media-wrapper" style="width:370px;height:554px;background:#f0ede8;flex-shrink:0;">
           <img src="${escapeAttr(imgSrc.split('?')[0] + '?width=370')}" alt="${escapeAttr(productTitle)}"
             loading="eager" width="370" height="554" style="width:370px;height:554px;object-fit:cover;display:block;" />
         </div>`
      : '';

    // Size picker
    let sizePickerHtml = '';
    if (needsSizeSelect) {
      sizePickerHtml = `
        <div class="xgen-qs-sizes" data-form-id="xgen-pf-${escapeAttr(String(productId))}">
          ${sizeOptions.map(s => {
            const isOos = !allOos && !s.available;
            return `<button type="button"
              class="xgen-qs-size-btn${isOos ? ' xgen-qs-oos' : ''}"
              data-variant-id="${escapeAttr(s.variantId)}"
              ${isOos ? 'disabled' : ''}>
              ${escapeHtml(s.label)}
            </button>`;
          }).join('')}
        </div>`;
    }

    const modal = document.createElement('gdl-quick-shop-modal-dialog');
    modal.id = `quick-shop-modal-xg-${String(productId)}`;
    modal.className = 'quick-shop-popup-modal';
    modal.innerHTML = `
      <div class="quick-shop-modal-container">
        <div role="dialog" aria-label="quick shop" aria-modal="true"
          class="quick-shop-product-det" tabindex="-1">
          <div class="quick-shop-modal__content-info">
            <div class="quick-shop-product-det">
              <div class="qs-product--wrapper">
                ${imgTag}
                <div class="qs-product-info">
                  <div class="qs-product-info--wrapper">
                    <button id="ModalClose-xg-${escapeAttr(String(productId))}"
                      type="button" class="product-popup-modal__toggle" aria-label="Close">
                      ${CLOSE_ICON}
                    </button>
                    <div class="qs-product-content">
                      <div class="qs-product-details">
                        <span class="qs-product-heading">
                          <h2 class="qs-card_product-title">${escapeHtml(productTitle)}</h2>
                        </span>
                        <span>${priceHtml}</span>
                      </div>
                      <div class="qs-product-variant">
                        <div class="size-variant-cont">
                          ${sizePickerHtml}
                          <div class="qs-product-buy-button">
                            <product-form class="product-form">
                              <form id="xgen-pf-${escapeAttr(String(productId))}"
                                action="/cart/add" method="post" class="form"
                                novalidate data-type="add-to-cart-form">
                                <input type="hidden" name="id" value="${escapeAttr(firstVariantId)}">
                                <div class="product-form__buttons">
                                  <button type="submit" name="add" id="product-form-submit-btn"
                                    class="product-form__submit button button--full-width button--primary"
                                    ${needsSizeSelect ? 'disabled' : ''}>
                                    <span>${needsSizeSelect ? escapeHtml(selectText) : escapeHtml(addText)}</span>
                                    ${SPINNER}
                                  </button>
                                </div>
                              </form>
                            </product-form>
                          </div>
                        </div>
                      </div>
                      <div class="qs-product-view-det">
                        <a href="${escapeAttr(productUrl)}" class="full-unstyled-link">
                          <span>${escapeHtml(viewText)}</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>`;

    return { modal, needsSizeSelect, productId };
  }

  function initQuickShop(grid) {
    const locale = (window.Shopify?.locale || 'it').split('-')[0].toLowerCase();
    const addText = locale === 'it' ? 'AGGIUNGI AL CARRELLO' : 'ADD TO CART';
    const selectText = locale === 'it' ? 'SELEZIONA LA TAGLIA' : 'SELECT SIZE';
    const viewText = locale === 'it' ? 'Vedi i dettagli' : 'View details';

    function prefetchProduct(trigger) {
      const productUrl = trigger?.dataset.productUrl;
      const productId = trigger?.dataset.productId;
      if (!productUrl || !productId || QS_FETCH_CACHE[productId]) return;
      QS_FETCH_CACHE[productId] = Promise.all([
        fetch(`${productUrl}.json`)
          .then(r => r.ok ? r.json() : Promise.reject(r.status))
          .then(d => {
            const p = d.product;
            // Preload image into browser cache while user is still deciding
            const rawSrc = p?.featured_image;
            const src = rawSrc ? (typeof rawSrc === 'string' ? rawSrc : (rawSrc.src || '')) : (p?.images?.[0]?.src || '');
            if (src) { const img = new Image(); img.src = src.split('?')[0] + '?width=370'; }
            return p;
          })
          .catch(() => null),
        fetchVariantAvailability(productUrl),
      ]);
    }

    // Prefetch on desktop hover
    grid.addEventListener('pointerover', (e) => {
      const trigger = e.target.closest('.xgen-qs-trigger');
      if (trigger) prefetchProduct(trigger);
    });

    // Prefetch on mobile tap-start (fires before click)
    grid.addEventListener('touchstart', (e) => {
      const trigger = e.target.closest('.xgen-qs-trigger');
      if (trigger) prefetchProduct(trigger);
    }, { passive: true });

    grid.addEventListener('click', async (e) => {
      const trigger = e.target.closest('.xgen-qs-trigger');
      if (!trigger) return;
      e.preventDefault();

      const productUrl = trigger.dataset.productUrl;
      const productId = trigger.dataset.productId;
      if (!productUrl || !productId) return;

      // Loading state on trigger button
      trigger.disabled = true;
      const originalHtml = trigger.innerHTML;
      trigger.innerHTML = `<svg viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg" style="width:18px;height:18px;animation:xgen-rec-spin 0.8s linear infinite;"><circle fill="none" stroke="currentColor" stroke-width="6" cx="33" cy="33" r="30" stroke-dasharray="150 200" stroke-dashoffset="-10" stroke-linecap="round"></circle></svg>`;

      try {
        // Parallelize: product JSON (variants/price/image) + section HTML (accurate availability)
        if (!QS_FETCH_CACHE[productId]) {
          QS_FETCH_CACHE[productId] = Promise.all([
            fetch(`${productUrl}.json`)
              .then(r => r.ok ? r.json() : Promise.reject(r.status))
              .then(d => d.product)
              .catch(() => null),
            fetchVariantAvailability(productUrl),
          ]);
        }
        const [productData, availabilityMap] = await QS_FETCH_CACHE[productId];
        if (!productData) return;

        // Remove stale modal if exists (e.g. re-opened after page mutation)
        document.getElementById(`quick-shop-modal-xg-${productId}`)?.remove();

        const { modal, needsSizeSelect } = buildQuickShopModalEl(
          productData, productId, productUrl, { addText, selectText, viewText, availabilityMap }
        );

        // Close button
        modal.querySelector(`#ModalClose-xg-${productId}`)
          ?.addEventListener('click', () => typeof modal.hide === 'function' && modal.hide());

        // Size button clicks — bind directly since modal is not yet at body level
        if (needsSizeSelect) {
          modal.querySelectorAll('.xgen-qs-size-btn:not([disabled])').forEach(btn => {
            btn.addEventListener('click', () => {
              modal.querySelectorAll('.xgen-qs-size-btn').forEach(b => b.classList.remove('xgen-qs-active'));
              btn.classList.add('xgen-qs-active');
              const form = modal.querySelector(`#xgen-pf-${productId}`);
              if (!form) return;
              const input = form.querySelector('input[name="id"]');
              if (input) input.value = btn.dataset.variantId;
              const submit = form.querySelector('button[type="submit"]');
              if (submit) {
                submit.disabled = false;
                const span = submit.querySelector('span');
                if (span) span.textContent = addText;
              }
            });
          });
        }

        // Append to body → connectedCallback runs (moves dialog to body if not already there)
        document.body.appendChild(modal);
        // Show after a frame so the browser registers the element before opening
        requestAnimationFrame(() => {
          if (typeof modal.show === 'function') modal.show(trigger);
        });

      } finally {
        trigger.disabled = false;
        trigger.innerHTML = originalHtml;
      }
    });
  }


  // ─── IMAGE CAROUSEL (CSS-based, no Swiper) ─────────────────────────────────
  // Slide n sits at n * (slide width + gap). The percentage in translateX resolves against
  // the track's own width — which is one slide — so the gap has to be added separately, once
  // per slide stepped over. It stays a CSS var (--xgen-card-gap, set on .xgen-rec-card-track)
  // so the spacing is defined in one place and this math follows it automatically.
  function offsetFor(position) {
    return `translateX(calc(-${position * 100}% - ${position} * var(--xgen-card-gap, 0px)))`;
  }

  function initCardSwipe(grid) {
    if (grid._xgenRecSwipeInit) return;
    grid._xgenRecSwipeInit = true;

    // Track layout is [clone(last), ...real slides..., clone(first)], so a real
    // index i lives at track position i+1. Requesting one step past either edge
    // (visual === -1 or === count) slides into the matching clone, then snaps
    // invisibly to the real slide at the same position — giving a seamless loop
    // instead of a jarring rewind across every slide back to the start.
    function goToSlide(media, visual) {
      const count = parseInt(media.dataset.slideCount, 10) || 1;
      if (count < 2) return;
      const track = media.querySelector('.xgen-rec-card-track');
      if (!track) return;
      const realIndex = ((visual % count) + count) % count;
      const trackPos = visual + 1;

      track.style.willChange = 'transform';
      track.style.transition = 'transform 0.3s ease';
      track.style.transform = offsetFor(trackPos);
      media.dataset.slideVisual = realIndex;

      if (visual === -1 || visual === count) {
        const snapPos = realIndex + 1;
        setTimeout(() => {
          track.style.transition = 'none';
          track.style.transform = offsetFor(snapPos);
          track.offsetHeight; // force reflow before re-enabling transitions
          track.style.transition = 'transform 0.3s ease';
        }, 320);
      }

      setTimeout(() => { track.style.willChange = 'auto'; }, 320);
    }

    grid.addEventListener('click', (e) => {
      const arrow = e.target.closest('.xgen-rec-arrow');
      if (!arrow) return;
      e.preventDefault();
      const media = arrow.closest('.xgen-rec-card-media');
      const visual = parseInt(media.dataset.slideVisual, 10) || 0;
      goToSlide(media, arrow.classList.contains('xgen-rec-arrow--next') ? visual + 1 : visual - 1);
    });

    let touchStartX = 0;
    let touchMedia = null;
    grid.addEventListener('touchstart', (e) => {
      if (window.matchMedia('(max-width: 749px)').matches) return;
      touchStartX = e.changedTouches[0].screenX;
      touchMedia = e.target.closest('.xgen-rec-card-media');
    }, { passive: true });
    grid.addEventListener('touchend', (e) => {
      if (!touchMedia) return;
      const diff = e.changedTouches[0].screenX - touchStartX;
      if (Math.abs(diff) > 30) {
        const visual = parseInt(touchMedia.dataset.slideVisual, 10) || 0;
        goToSlide(touchMedia, diff < 0 ? visual + 1 : visual - 1);
      }
      touchMedia = null;
    }, { passive: true });
  }

  // ─── MOBILE PROGRESS BAR ───────────────────────────────────────────────────
  // Driven from here (not an inline <script> in the snippet) because the cart
  // drawer re-renders its content via innerHTML on add/update, and injected
  // <script> tags never execute in that case — only this persistently-wired
  // init path reliably re-runs afterwards.
  function initProgressBar(grid) {
    const slider = grid.closest('slider-component');
    if (!slider || slider._xgenProgressInit) return;
    const bar = slider.querySelector('.xgen-rec-progress__bar');
    const track = slider.querySelector('.xgen-rec-progress');
    if (!bar || !track) return;
    slider._xgenProgressInit = true;

    const scroller = grid;
    const EPS = 2, SCROLL_END_MS = 140;
    let geom = { total: 0, barW: 0, maxBarX: 0 };

    function getSlides() { return Array.from(scroller.querySelectorAll('.slider__slide')); }
    function setGeom() {
      const total = getSlides().length;
      const trackW = track.clientWidth || 1;
      const barW = Math.max(1, trackW / Math.max(1, total));
      bar.style.width = barW + 'px';
      geom = { total, barW, maxBarX: Math.max(0, trackW - barW) };
    }
    function getMaxScroll() { return Math.max(0, scroller.scrollWidth - scroller.clientWidth); }
    function getProgress01() {
      const m = getMaxScroll();
      return m <= 0 ? 0 : Math.max(0, Math.min(1, scroller.scrollLeft / m));
    }
    function updateBar() {
      if (!geom.total) setGeom();
      const x = geom.maxBarX * getProgress01();
      bar.style.transform = 'translate3d(' + (Math.round(x * 10) / 10) + 'px,0,0)';
    }

    let scrollEndT = null;
    function markScrolling() {
      slider.classList.add('is-scrolling');
      clearTimeout(scrollEndT);
      scrollEndT = setTimeout(() => {
        slider.classList.remove('is-scrolling');
        // Never re-pin to the end while a finger is still down: the timer can fire in the
        // middle of a swipe back from the last card and drag the carousel forward again.
        const m = getMaxScroll();
        if (
          m > 0 &&
          !slider.classList.contains('is-dragging') &&
          scroller.scrollLeft >= m - EPS
        ) scroller.scrollLeft = m;
        updateBar();
      }, SCROLL_END_MS);
    }

    let raf = null;
    scroller.addEventListener('scroll', () => {
      markScrolling();
      if (raf) return;
      raf = requestAnimationFrame(() => { raf = null; updateBar(); });
    }, { passive: true });

    scroller.addEventListener('pointerdown', () => slider.classList.add('is-dragging'), { passive: true });
    window.addEventListener('pointerup', () => { slider.classList.remove('is-dragging'); markScrolling(); }, { passive: true });
    window.addEventListener('pointercancel', () => { slider.classList.remove('is-dragging'); markScrolling(); }, { passive: true });
    scroller.addEventListener('touchstart', () => slider.classList.add('is-dragging'), { passive: true });
    scroller.addEventListener('touchend', () => { slider.classList.remove('is-dragging'); markScrolling(); }, { passive: true });
    window.addEventListener('resize', () => requestAnimationFrame(() => { setGeom(); updateBar(); }));
    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(() => requestAnimationFrame(() => { setGeom(); updateBar(); }));
      ro.observe(scroller); ro.observe(track);
    }

    requestAnimationFrame(() => { setGeom(); updateBar(); });
  }

  // ─── WISHLIST ──────────────────────────────────────────────────────────────
  if (!window.SwymCallbacks) window.SwymCallbacks = [];
  window.SwymCallbacks.push(function (swat) {
    recSwat = swat;
    fetchRecWishlist();
  });

  function fetchRecWishlist() {
    if (!recSwat || !isCustomerLoggedIn()) return;
    recSwat.fetchLists({
      callbackFn: (lists) => {
        lists = (lists || []).slice().reverse();
        const selected = lists[0];
        if (!selected) return;
        recWishlistListId = recSwat.swymCustomWishlistSelectedListId || selected.lid;
        recSwat.swymCustomWishlistSelectedListId = recWishlistListId;
        recWishlistedSet = {};
        (selected.listcontents || []).forEach(it => {
          if (it.empi != null) recWishlistedSet[String(it.empi)] = { epi: it.epi, du: it.du };
        });
        document.querySelectorAll('.xgen-rec-wishlist-btn[data-empi]').forEach(btn => {
          setWishlistBtnState(btn, !!recWishlistedSet[String(btn.dataset.empi)]);
        });
      },
      errorFn: (e) => console.warn('[XGen Rec] fetchLists error:', e),
    });
  }

  function setWishlistBtnState(btn, added) {
    btn.classList.toggle('xgen-wl-added', added);
    btn.innerHTML = added ? WISHLIST_ICON_FULL : WISHLIST_ICON_EMPTY;
  }

  function bindWishlistToGrid(grid) {
    grid.addEventListener('click', async (e) => {
      const trigger = e.target.closest('.xgen-wishlist-trigger');
      if (trigger) { e.preventDefault(); openLoginPopup(); return; }
      const btn = e.target.closest('.xgen-rec-wishlist-btn');
      if (!btn || btn.classList.contains('xgen-wishlist-trigger')) return;
      e.preventDefault();
      await toggleWishlist(btn);
    });
  }

  async function toggleWishlist(btn) {
    if (!recSwat || !recWishlistListId) return;
    const empi = String(btn.dataset.empi);
    const du = btn.dataset.productUrl;
    const isAdded = btn.classList.contains('xgen-wl-added');
    btn.disabled = true;

    if (isAdded) {
      const stored = recWishlistedSet[empi] || {};
      recSwat.deleteFromList(
        recWishlistListId,
        { epi: stored.epi, empi: Number(empi) || empi, du: stored.du || du },
        () => { delete recWishlistedSet[empi]; setWishlistBtnState(btn, false); btn.disabled = false; },
        (e) => { console.warn('[XGen Rec] deleteFromList error:', e); btn.disabled = false; }
      );
      return;
    }

    let epi = null, dt = '', iu = '', pr = 0;
    try {
      const res = await fetch(`${du}.js`);
      const pd = await res.json();
      const v = pd.variants?.[0];
      epi = v?.id;
      dt = pd.title || '';
      iu = pd.featured_image || pd.images?.[0] || '';
      pr = v ? v.price : 0;
    } catch (e) { console.warn('[XGen Rec] product fetch error:', e); }

    recSwat.addToList(
      recWishlistListId,
      { epi, empi: Number(empi) || empi, du, dt, iu, pr },
      () => { recWishlistedSet[empi] = { epi, du }; setWishlistBtnState(btn, true); btn.disabled = false; },
      (e) => { console.warn('[XGen Rec] addToList error:', e); btn.disabled = false; }
    );
  }

  function openLoginPopup() {
    const popup = document.getElementById('login-popup');
    if (!popup) return;
    popup.style.zIndex = '100002';
    popup.classList.add('active');
  }

  // ─── INIT ──────────────────────────────────────────────────────────────────
  // Written by product-form.js on every successful add to cart. Read defensively: Safari in
  // private mode throws on sessionStorage access.
  function getLastAddedProductId() {
    try { return sessionStorage.getItem('xgen:last_added_product_id') || null; }
    catch (e) { return null; }
  }

  function showFallback(sectionEl) {
    const parent = sectionEl?.parentElement;
    if (!parent) return;
    const fallback = parent.querySelector('[data-xgen-rec-fallback]');
    if (fallback) fallback.removeAttribute('hidden');
    const cartFallback = parent.querySelector('.fall-back-xgen-cart');
    if (cartFallback) cartFallback.classList.remove('fall-back-xgen-cart');
  }

  // A secondary grid (e.g. the PDP "Recently viewed" tab) shares its section with the primary
  // one, which alone decides whether the section or its Liquid fallback is shown.
  function isSecondaryGrid(grid) {
    return grid.dataset.xgenRecSecondary === 'true';
  }

  function handleEmptyGrid(grid, sectionEl) {
    if (!isSecondaryGrid(grid)) {
      sectionEl?.setAttribute('hidden', '');
      showFallback(sectionEl);
    }
    notifyRendered(grid, 0);
  }

  // Lets the section's own script react to the outcome (e.g. reveal the Recently viewed tab).
  function notifyRendered(grid, count) {
    grid.dispatchEvent(new CustomEvent('xgen:rec-rendered', { detail: { count } }));
  }

  async function initRecommendations() {
    const grids = document.querySelectorAll('[data-xgen-rec-grid]');
    if (!grids.length) return;

    // The cart drawer renders its "empty" and "has items" states as separate DOM blocks
    // that both exist at once (CSS just toggles which is visible), so the same containerId
    // (e.g. sm_el_mini_cart) can show up on two grids simultaneously. Cache the in-flight
    // request per containerId so duplicates reuse the same response instead of firing a
    // second API call.
    const requestsByContainer = new Map();

    for (const grid of grids) {
      if (grid.dataset.xgenRecLoaded) continue;

      // A carrello vuoto il drawer tiene comunque nel DOM il blocco upsell "pieno", solo
      // nascosto (cart-drawer-items.is-empty → display:none). Quel grid porta il containerId
      // dello stato pieno (sm_el_mini_cart / sm_el_cart_page): elaborarlo manderebbe una
      // seconda chiamata a XGen accanto a quella dello stato vuoto. Lo saltiamo finché è
      // nascosto; quando il carrello si riempie il drawer viene ri-renderizzato senza is-empty
      // e il MutationObserver lo rielabora.
      if (grid.closest('cart-drawer-items.is-empty')) continue;

      const containerId = grid.dataset.xgenRecGrid;
      const limit = parseInt(grid.dataset.limit, 10) || 4;
      const pathname = grid.dataset.pathname || window.location.pathname;
      const sectionEl = grid.closest('[data-xgen-rec-section]');

      if (!containerId) {
        handleEmptyGrid(grid, sectionEl);
        continue;
      }

      let context;
      if (grid.dataset.xgenContext) {
        try { context = JSON.parse(grid.dataset.xgenContext); }
        catch (e) { console.warn('[XGen Rec] invalid data-xgen-context JSON:', e); }
      }

      // In the cart/drawer the "current product" is the one just added, which we can't infer
      // from the position of a line inside cart.items. Liquid ships a context per cart product
      // in data-xgen-context-map; here we pick the entry for the id recorded by the last
      // successful add to cart, and fall back to the Liquid seed when that product is gone.
      const lastAddedId = getLastAddedProductId();
      if (lastAddedId && grid.dataset.xgenContextMap) {
        try {
          const contextMap = JSON.parse(grid.dataset.xgenContextMap);
          if (contextMap[lastAddedId]) context = contextMap[lastAddedId];
        } catch (e) { console.warn('[XGen Rec] invalid data-xgen-context-map JSON:', e); }
      }

      // Merchandising rules whose filters reference a property of the current product resolve
      // that reference through pdpCode — a top-level context field, distinct from the prod_code
      // we send inside the merchandising context. Without it the rule can't evaluate and XGen
      // silently serves the fallback rule instead. The catalog is keyed on the Shopify product
      // id, so the seed's prod_code is the right value (drawer included, where the "current
      // product" is the last item added to the cart).
      const pdpCode = context?.prod_code != null ? String(context.prod_code) : null;

      // Browsing history recorded by xgen-script.liquid; needed by "recently viewed"
      // experiences and used by the others for personalization.
      const recentlyViewed = window.xgenGetRecentlyViewed?.() || [];
      // The current PDP is already at the top of that history (recorded on page load), so a
      // "recently viewed" grid would otherwise list the very product being looked at.
      const exclude = grid.dataset.xgenExcludeCurrent === 'true' && pdpCode ? [pdpCode] : [];

      try {
        if (!requestsByContainer.has(containerId)) {
          requestsByContainer.set(containerId, window.xg.recommend.getResultsById({
            containerId,
            options: {
              pathname,
              ...(pdpCode ? { pdpCode } : {}),
              ...(recentlyViewed.length ? { recentlyViewed } : {}),
              ...(exclude.length ? { exclude } : {}),
              ...(context ? { context } : {}),
            },
          }));
        }
        const response = await requestsByContainer.get(containerId);

        const items = (response?.items || response?.products_list || []).slice(0, limit);

        if (!items.length) {
          handleEmptyGrid(grid, sectionEl);
          continue;
        }

        if (window.xgenHelpers) {
          await window.xgenHelpers.enrichProductsWithShopifyData(items);
        }

        const total = items.length;
        const showWishlist = grid.dataset.hideWishlist !== 'true';
        const showQuickbuy = grid.dataset.hideQuickbuy !== 'true';
        const onlyOneImg = grid.dataset.onlyOneImg === 'true';
        const priceInHover = grid.dataset.priceInHover === 'true';
        grid.innerHTML = items.map((item, i) => buildRecCardHtml(item, i + 1, total, grid.id, { showWishlist, showQuickbuy, onlyOneImg, priceInHover, elementId: containerId })).join('');

        if (!isSecondaryGrid(grid)) {
          sectionEl?.removeAttribute('hidden');
          sectionEl?.classList.add('product-recommendations--loaded');
        }

        grid.dataset.xgenRecLoaded = 'true';
        initCardSwipe(grid);
        bindWishlistToGrid(grid);
        initQuickShop(grid);
        initProgressBar(grid);
        // Tabbed grids sit in their own panel: observing the panel means element_view fires
        // only once that tab is actually shown, not as soon as the section scrolls into view.
        trackElementEvents(grid, grid.closest('[data-xgen-rec-panel]') || sectionEl, containerId, items);
        notifyRendered(grid, items.length);

        // Notify slider-component and progress bar of new content
        window.dispatchEvent(new Event('resize'));
        // Re-trigger fostr-carousel-button state now that cards are loaded
        requestAnimationFrame(() => grid.dispatchEvent(new Event('scroll', { bubbles: false })));

      } catch (err) {
        console.warn('[XGen Rec] getResultsById error:', err);
        handleEmptyGrid(grid, sectionEl);
      }
    }
  }

  function boot() {
    if (window.xgReady) {
      initRecommendations();
    } else {
      window.addEventListener('xgen:ready', initRecommendations, { once: true });
    }
    fetchRecWishlist();

    // Re-process grids injected after cart drawer re-renders (innerHTML replacement)
    const domObserver = new MutationObserver(mutations => {
      if (!window.xgReady) return;
      const hasNewGrid = mutations.some(m =>
        Array.from(m.addedNodes).some(node =>
          node.nodeType === 1 && (node.matches('[data-xgen-rec-grid]') || node.querySelector('[data-xgen-rec-grid]'))
        )
      );
      if (hasNewGrid) initRecommendations();
    });
    domObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
